import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M8 4.2v8.6m0-8.6c-.8-.5-1.8-.9-3-.9s-2.2.4-3 .9v8.6c.8-.5 1.8-.8 3-.8s2.2.3 3 .8m0-8.6c.8-.5 1.8-.9 3-.9s2.2.4 3 .9v8.6c-.8-.5-1.8-.8-3-.8s-2.2.3-3 .8",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }